
import { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import FloatingActions from '../../components/feature/FloatingActions';
import AnimatedSection from '../../components/base/AnimatedSection';

const ServicesPage = () => {
  const [activeCategory, setActiveCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'All Services', icon: 'ri-grid-line' },
    { id: 'dental', name: 'Dental Lab', icon: 'ri-tooth-line' },
    { id: 'medical', name: 'Medical Testing', icon: 'ri-test-tube-line' },
    { id: 'diagnostic', name: 'Diagnostics', icon: 'ri-heart-pulse-line' },
    { id: 'research', name: 'Research', icon: 'ri-microscope-line' },
  ];

  const services = [
    {
      category: 'dental',
      image: 'https://public.readdy.ai/ai/img_res/2eebc586655fdec2c75772ee97c66f64.jpg',
      title: 'Dental Crowns & Bridges',
      description: 'Premium quality ceramic and zirconia crowns and bridges with natural aesthetics and superior durability for long-lasting results.',
      features: ['Custom color matching', 'CAD/CAM technology', '3-5 day turnaround', 'Lifetime warranty'],
    },
    {
      category: 'dental',
      image: 'https://readdy.ai/api/search-image?query=dental%20implant%20prosthetic%20on%20clean%20white%20medical%20background%20professional%20dental%20laboratory%20product%20high%20quality%20detailed%20precision%20titanium&width=600&height=400&seq=serv2&orientation=landscape',
      title: 'Dental Implants',
      description: 'Precision-crafted implant restorations using the latest digital technology for optimal fit and function.',
      features: ['Digital impressions', 'Titanium compatibility', 'Custom abutments', 'Expert consultation'],
    },
    {
      category: 'dental',
      image: 'https://readdy.ai/api/search-image?query=orthodontic%20appliances%20retainers%20on%20clean%20white%20medical%20background%20professional%20dental%20laboratory%20products%20high%20quality%20organized%20display&width=600&height=400&seq=serv3&orientation=landscape',
      title: 'Orthodontic Appliances',
      description: 'Complete range of orthodontic solutions including retainers, aligners, and specialized appliances.',
      features: ['Clear aligners', 'Custom retainers', 'Rapid fabrication', 'Precise fitting'],
    },
    {
      category: 'medical',
      image: 'https://readdy.ai/api/search-image?query=blood%20test%20tubes%20samples%20in%20laboratory%20rack%20on%20clean%20white%20medical%20background%20professional%20clinical%20testing%20high%20quality%20organized%20medical%20diagnostics&width=600&height=400&seq=serv4&orientation=landscape',
      title: 'Complete Blood Count',
      description: 'Comprehensive blood analysis including red cells, white cells, platelets, and hemoglobin levels.',
      features: ['Same-day results', 'Automated analysis', 'Quality verified', 'Digital reporting'],
    },
    {
      category: 'medical',
      image: 'https://readdy.ai/api/search-image?query=medical%20pathology%20microscope%20slides%20on%20clean%20white%20laboratory%20background%20professional%20diagnostic%20testing%20high%20quality%20clinical%20analysis&width=600&height=400&seq=serv5&orientation=landscape',
      title: 'Pathology Services',
      description: 'Expert pathological examination and diagnosis with board-certified pathologists.',
      features: ['Tissue analysis', 'Biopsy examination', 'Cancer screening', 'Expert consultation'],
    },
    {
      category: 'medical',
      image: 'https://readdy.ai/api/search-image?query=microbiology%20culture%20plates%20petri%20dishes%20on%20clean%20white%20laboratory%20background%20professional%20bacterial%20testing%20high%20quality%20clinical%20microbiology&width=600&height=400&seq=serv6&orientation=landscape',
      title: 'Microbiology Testing',
      description: 'Comprehensive bacterial, viral, and fungal identification with antibiotic sensitivity testing.',
      features: ['Culture & sensitivity', 'Rapid identification', 'Antibiotic testing', '24/7 availability'],
    },
    {
      category: 'diagnostic',
      image: 'https://readdy.ai/api/search-image?query=DNA%20genetic%20testing%20equipment%20on%20clean%20white%20laboratory%20background%20professional%20molecular%20diagnostics%20high%20quality%20scientific%20analysis&width=600&height=400&seq=serv7&orientation=landscape',
      title: 'Genetic Testing',
      description: 'Advanced molecular diagnostics for hereditary conditions, cancer screening, and personalized medicine.',
      features: ['DNA sequencing', 'Cancer markers', 'Hereditary screening', 'Genetic counseling'],
    },
    {
      category: 'diagnostic',
      image: 'https://readdy.ai/api/search-image?query=cardiac%20enzyme%20test%20equipment%20on%20clean%20white%20laboratory%20background%20professional%20heart%20diagnostic%20testing%20high%20quality%20clinical%20cardiology&width=600&height=400&seq=serv8&orientation=landscape',
      title: 'Cardiac Markers',
      description: 'Rapid cardiac enzyme testing for heart attack diagnosis and cardiovascular risk assessment.',
      features: ['Troponin testing', 'Emergency service', 'Rapid turnaround', 'Expert interpretation'],
    },
    {
      category: 'diagnostic',
      image: 'https://readdy.ai/api/search-image?query=hormone%20blood%20test%20vials%20on%20clean%20white%20laboratory%20background%20professional%20endocrine%20testing%20high%20quality%20clinical%20diagnostics&width=600&height=400&seq=serv9&orientation=landscape',
      title: 'Hormone Testing',
      description: 'Comprehensive endocrine panel testing for thyroid, reproductive, and metabolic hormones.',
      features: ['Thyroid panel', 'Reproductive hormones', 'Metabolic screening', 'Expert analysis'],
    },
    {
      category: 'research',
      image: 'https://readdy.ai/api/search-image?query=clinical%20trial%20laboratory%20research%20on%20clean%20white%20medical%20background%20professional%20pharmaceutical%20testing%20high%20quality%20scientific%20research&width=600&height=400&seq=serv10&orientation=landscape',
      title: 'Clinical Trials',
      description: 'Comprehensive laboratory support for clinical research and pharmaceutical development.',
      features: ['GCP compliance', 'Sample management', 'Data analysis', 'Regulatory support'],
    },
    {
      category: 'research',
      image: 'https://readdy.ai/api/search-image?query=pharmaceutical%20drug%20testing%20equipment%20on%20clean%20white%20laboratory%20background%20professional%20quality%20control%20high%20quality%20scientific%20analysis&width=600&height=400&seq=serv11&orientation=landscape',
      title: 'Drug Testing',
      description: 'Accurate and confidential drug screening for workplace, legal, and medical purposes.',
      features: ['Multi-panel screening', 'Confirmation testing', 'Chain of custody', 'Rapid results'],
    },
    {
      category: 'research',
      image: 'https://readdy.ai/api/search-image?query=quality%20control%20laboratory%20testing%20on%20clean%20white%20medical%20background%20professional%20validation%20equipment%20high%20quality%20scientific%20standards&width=600&height=400&seq=serv12&orientation=landscape',
      title: 'Quality Control',
      description: 'Rigorous quality assurance and validation services for pharmaceutical and medical device industries.',
      features: ['Method validation', 'Stability testing', 'Regulatory compliance', 'Documentation'],
    },
  ];

  const filteredServices = activeCategory === 'all' 
    ? services 
    : services.filter(service => service.category === activeCategory);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <FloatingActions />

      {/* Hero Section */}
      <section className="relative h-[60vh] flex items-center justify-center overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(https://readdy.ai/api/search-image?query=modern%20medical%20laboratory%20services%20equipment%20and%20technology%20clean%20professional%20healthcare%20facility%20bright%20environment%20high%20quality%20diagnostic%20center&width=1920&height=800&seq=services-hero&orientation=landscape)',
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-primary-900/80 to-royal-900/70"></div>
        </div>

        <div className="relative z-10 text-center text-white px-6">
          <h1 className="text-5xl lg:text-6xl font-display font-bold mb-4">Our Services</h1>
          <p className="text-xl mb-6 max-w-2xl mx-auto">
            Comprehensive laboratory solutions tailored to your healthcare needs
          </p>
          <div className="flex items-center justify-center space-x-2 text-white/80">
            <Link to="/" className="hover:text-white transition-colors duration-300">Home</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span>Services</span>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="grid lg:grid-cols-4 gap-8">
            {/* Sidebar - Categories */}
            <div className="lg:col-span-1">
              <div className="bg-white rounded-2xl shadow-lg p-6 sticky top-24">
                <h3 className="text-xl font-display font-bold text-gray-900 mb-6">Categories</h3>
                <div className="space-y-2">
                  {categories.map((category) => (
                    <button
                      key={category.id}
                      onClick={() => setActiveCategory(category.id)}
                      className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-all duration-300 cursor-pointer ${
                        activeCategory === category.id
                          ? 'bg-primary-500 text-white shadow-lg'
                          : 'text-gray-700 hover:bg-gray-100'
                      }`}
                    >
                      <div className="w-6 h-6 flex items-center justify-center">
                        <i className={`${category.icon} text-xl`}></i>
                      </div>
                      <span className="font-medium">{category.name}</span>
                    </button>
                  ))}
                </div>

                <div className="mt-8 p-6 bg-gradient-to-br from-primary-500 to-royal-600 rounded-2xl text-white">
                  <h4 className="font-bold mb-2">Need Help?</h4>
                  <p className="text-sm text-white/90 mb-4">
                    Our experts are here to assist you
                  </p>
                  <Link
                    to="/contact"
                    className="block w-full px-4 py-2 bg-white text-primary-600 rounded-lg text-center font-semibold hover:bg-cyan-50 transition-all duration-300 whitespace-nowrap"
                  >
                    Contact Us
                  </Link>
                </div>
              </div>
            </div>

            {/* Services Grid */}
            <div className="lg:col-span-3">
              <div className="mb-8">
                <h2 className="text-3xl font-display font-bold text-gray-900 mb-2">
                  {categories.find(c => c.id === activeCategory)?.name}
                </h2>
                <p className="text-gray-600">
                  {filteredServices.length} service{filteredServices.length !== 1 ? 's' : ''} available
                </p>
              </div>

              <div className="grid md:grid-cols-2 gap-8">
                {filteredServices.map((service, index) => (
                  <AnimatedSection key={index} delay={index * 0.1}>
                    <div className="group bg-white rounded-3xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300">
                      <div className="relative h-64 overflow-hidden">
                        <img
                          src={service.image}
                          alt={service.title}
                          className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                        />
                        <div className="absolute top-4 left-4">
                          <span className="px-3 py-1 bg-white/90 backdrop-blur-sm text-primary-600 rounded-full text-sm font-semibold capitalize">
                            {service.category}
                          </span>
                        </div>
                      </div>
                      <div className="p-8">
                        <h3 className="text-2xl font-display font-bold text-gray-900 mb-3">{service.title}</h3>
                        <p className="text-gray-600 mb-6 leading-relaxed">{service.description}</p>
                        
                        <div className="space-y-2 mb-6">
                          {service.features.map((feature, idx) => (
                            <div key={idx} className="flex items-center space-x-2 text-sm text-gray-600">
                              <i className="ri-checkbox-circle-fill text-green-500"></i>
                              <span>{feature}</span>
                            </div>
                          ))}
                        </div>

                        <div className="flex space-x-3">
                          <Link
                            to="/quote"
                            className="flex-1 px-6 py-3 bg-gradient-to-r from-primary-500 to-royal-600 text-white rounded-lg font-semibold text-center hover:shadow-lg hover:scale-105 transition-all duration-300 whitespace-nowrap"
                          >
                            Request Quote
                          </Link>
                          <Link
                            to="/contact"
                            className="px-6 py-3 border-2 border-primary-500 text-primary-600 rounded-lg font-semibold hover:bg-primary-500 hover:text-white transition-all duration-300 whitespace-nowrap"
                          >
                            Learn More
                          </Link>
                        </div>
                      </div>
                    </div>
                  </AnimatedSection>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <AnimatedSection className="py-24 bg-gradient-to-r from-primary-600 to-royal-600">
        <div className="max-w-4xl mx-auto px-6 lg:px-12 text-center">
          <h2 className="text-4xl lg:text-5xl font-display font-bold text-white mb-6">
            Ready to Experience Excellence?
          </h2>
          <p className="text-xl text-white/90 mb-10 leading-relaxed">
            Get started with our comprehensive laboratory services today
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link
              to="/quote"
              className="px-10 py-4 bg-white text-primary-600 rounded-lg font-semibold hover:bg-cyan-50 hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap"
            >
              Request a Quote
            </Link>
            <Link
              to="/contact"
              className="px-10 py-4 bg-transparent border-2 border-white text-white rounded-lg font-semibold hover:bg-white hover:text-primary-600 transition-all duration-300 whitespace-nowrap"
            >
              Contact Us
            </Link>
          </div>
        </div>
      </AnimatedSection>

      <Footer />
    </div>
  );
};

export default ServicesPage;
